import z from 'zod';
import { reportSchema, reportListResponseSchema, reportKindSchema, reportStatusSchema } from './schemas';

export type Report = z.infer<typeof reportSchema>;
export type ReportListResponse = z.infer<typeof reportListResponseSchema>;
export type ReportKind = z.infer<typeof reportKindSchema>;
export const REPORT_KINDS = reportKindSchema.options;

export type ReportStatus = z.infer<typeof reportStatusSchema>;
